module.exports = __webpack_public_path__ + "media/ulcerative colitis.5bb1ef18.wav";